var _path, _path2, _g, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.724H8.828A8.829 8.829 0 0 1 0 414.896V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.792a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#4173cd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.999 384c-70.577 0-128-57.422-128-128s57.422-128 128-128 128 57.422 128 128-57.422 128-128 128zm0-229.517c-55.979 0-101.517 45.539-101.517 101.517s45.539 101.517 101.517 101.517S357.516 311.978 357.516 256s-45.538-101.517-101.517-101.517z",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffdc00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.999 375.172c-65.711 0-119.172-53.461-119.172-119.172s53.461-119.172 119.172-119.172S375.172 190.289 375.172 256s-53.461 119.172-119.173 119.172zm0-229.517c-60.845 0-110.345 49.499-110.345 110.345s49.499 110.345 110.345 110.345S366.344 316.845 366.344 256s-49.499-110.345-110.345-110.345z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.24,
    cy: 256,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.76,
    cy: 256,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 141.24,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.85,
    cy: 174.85,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.15,
    cy: 174.85,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.02,
    cy: 212.08,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.08,
    cy: 149.98,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.98,
    cy: 212.08,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.92,
    cy: 149.98,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.55,
    cy: 233.61,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.61,
    cy: 143.45,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.58,
    cy: 192.24,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.76,
    cy: 160.59,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.41,
    cy: 192.24,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.24,
    cy: 160.59,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.45,
    cy: 233.61,
    r: 8.828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.39,
    cy: 143.45,
    r: 8.828
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M370.758 260.414a4.411 4.411 0 0 1-4.414-4.414c0-60.845-49.499-110.345-110.345-110.345S145.655 195.156 145.655 256c0 2.44-1.974 4.414-4.414 4.414s-4.414-1.974-4.414-4.414c0-65.711 53.461-119.172 119.172-119.172S375.172 190.289 375.172 256a4.411 4.411 0 0 1-4.414 4.414z",
    fill: "#ffa000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280.527 388.414h-49.054c-10.482 0-18.656-9.079-17.558-19.503l15.602-148.22h52.965l15.602 148.22c1.098 10.424-7.076 19.503-17.557 19.503z",
    fill: "#b4b4b4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M282.232 220.69h-52.671a4.547 4.547 0 0 1-4.52-4.055l-3.29-30.302c-.567-5.221 3.523-9.781 8.776-9.781h50.945c5.252 0 9.343 4.558 8.776 9.781l-3.268 30.098a4.775 4.775 0 0 1-4.748 4.259z",
    fill: "#aaa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.044 186.834l16.364 47.079 49.831 1.015c2.051.042 2.899 2.648 1.263 3.889l-39.717 30.111 14.433 47.705c.594 1.964-1.623 3.575-3.308 2.403L256 290.568l-40.911 28.468c-1.684 1.172-3.902-.439-3.308-2.403l14.433-47.705-39.717-30.111c-1.635-1.239-.788-3.847 1.263-3.889l49.831-1.015 16.364-47.079c.674-1.939 3.415-1.939 4.089 0z",
    fill: "#f5f5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp);
export default __webpack_public_path__ + "static/media/mp.11f13318aac20a69991555a217c1b67b.svg";
export { ForwardRef as ReactComponent };